'use client'

import { useEffect } from 'react'

import { useRouter, usePathname } from 'next/navigation'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

import type { ChildrenType } from '@core/types'
import type { Locale } from '@configs/i18n'

import { useAuth } from '@/contexts/auth-context'
import { getLocalizedUrl } from '@/utils/i18n'

const RequirePasswordChange = ({ children, locale }: ChildrenType & { locale: Locale }) => {
  const { isLoading, isAuthenticated, mustChangePassword } = useAuth()
  const router = useRouter()
  const pathname = usePathname()
  const targetPath = getLocalizedUrl('/cambiar-contrasena', locale)
  const blocked = !isLoading && isAuthenticated && mustChangePassword && pathname !== targetPath

  useEffect(() => {
    if (blocked) {
      router.replace(targetPath)
    }
  }, [blocked, router, targetPath])

  if (blocked) {
    return (
      <Box sx={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  return <>{children}</>
}

export default RequirePasswordChange
